// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/layout-grid.js';

import { paths } from '../generated/layout-grid';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('layout-grid', Original, paths);
